"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Action_1 = require("./Action");
const Snackbar = ({ onClick, onClose, severity, type, message, buttonText, autoHideDuration, anchorOrigin, }) => {
    const [open, setOpen] = (0, react_1.useState)(true);
    const isAlert = type === "alert" || undefined;
    const Alert = react_1.default.memo(Action_1.SnackbarAction);
    const handleOnClick = () => {
        onClick();
        setOpen(false);
    };
    const handleClose = (reason) => {
        if (reason !== "clickaway") {
            setOpen(false);
            onClose();
        }
    };
    return (react_1.default.createElement(material_1.Snackbar, { anchorOrigin: anchorOrigin, open: open, autoHideDuration: autoHideDuration, onClose: (_, reason) => handleClose(reason), message: message, action: react_1.default.createElement(Action_1.SnackbarAction, { onClick: handleOnClick, onClose: handleClose, buttonText: buttonText, message: "" }) }, isAlert && (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Alert, { elevation: 6, variant: "filled", severity: severity },
            react_1.default.createElement(Alert, { buttonStyle: ({ theme }) => ({
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
                    color: theme.palette.snackBarAlertButton?.color,
                    paddingLeft: theme.spacing(1),
                    padding: 0,
                }), buttonText: buttonText, message: message, onClose: handleClose, onClick: handleOnClick }))))));
};
exports.default = Snackbar;
